import {useEffect, useState} from 'react';

import VectorIcon from '../VectorIcon';
import {useSocialShare} from '../../hooks';
import ReactModal from 'react-modal';

interface InviteFriendsModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function InviteFriendsModal({
  isOpen,
  onRequestClose,
}: InviteFriendsModalProps) {
  const [clipboardContent, setClipboardContent] = useState(null);
  useEffect(() => {
    if (
      clipboardContent &&
      typeof window !== 'undefined' &&
      typeof window.navigator !== 'undefined'
    ) {
      window.navigator.clipboard.writeText(clipboardContent);
    }
  }, [clipboardContent]);

  const {
    facebookShareUrl,
    twitterShareUrl,
    linkedinShareUrl,
    emailShareUrl,
    onShare,
  } = useSocialShare('/', 'The Whisky List');

  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content default-modal default-modal-large"
      overlayClassName="modal modal_active share-modal"
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        role="button"
        tabIndex={-1}
        onClick={onRequestClose}
        className="default-modal__close js-modal-close"
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div className="default-modal__box modal-review-header">
        <div className="font-20 mb-20 mt-20 text-center">
          Do you know any Whisky Lovers? <br /> Invite them to TWL
        </div>
      </div>
      <div className="default-modal__box">
        <div className="font-13 text-center text-gray">
          <strong>SHARE ON</strong>
        </div>
        <div className="share-circle-button__list">
          <div
            role="button"
            tabIndex={-1}
            onClick={() => onShare(facebookShareUrl)}
            className="share-circle-button__item"
          >
            <div className="share-circle-button__icon">
              <VectorIcon iconName="facebook-s" />
            </div>
            <div className="share-circle-button__text">Facebook</div>
          </div>

          <div
            role="button"
            tabIndex={-1}
            onClick={() => onShare(twitterShareUrl)}
            className="share-circle-button__item"
          >
            <div className="share-circle-button__icon">
              <VectorIcon iconName="twitter-s" />
            </div>
            <div className="share-circle-button__text">Twitter</div>
          </div>

          <div
            role="button"
            tabIndex={-1}
            onClick={() => onShare(linkedinShareUrl)}
            className="share-circle-button__item"
          >
            <div className="share-circle-button__icon">
              <VectorIcon iconName="linkedin-s" />
            </div>
            <div className="share-circle-button__text">Linkedin</div>
          </div>
          <div
            role="button"
            tabIndex={-1}
            onClick={() => onShare(emailShareUrl)}
            className="share-circle-button__item"
          >
            <div className="share-circle-button__icon">
              <VectorIcon iconName="email-s" />
            </div>
            <div className="share-circle-button__text">Email</div>
          </div>
          <div
            role="button"
            tabIndex={-1}
            onClick={() => setClipboardContent('https://thewhiskylist.com.au/')}
            className="share-circle-button__item"
          >
            <div className="share-circle-button__icon">
              <VectorIcon iconName="copy" />
            </div>
            <div className="share-circle-button__text">
              {clipboardContent ? 'Copied!' : 'Copy Link'}
            </div>
          </div>
        </div>
        <div className="font-14 text-center mt-25">Sharing is caring :)</div>
      </div>
    </ReactModal>
  );
}
